
// Rhis file can be used to write custom reusable JS functions

const id_seperator = '-id_'; // unique separator for rule id to avoid matching with reqular id value
/**
	 * Generate a unique rule ID
	 * @param {string} ruleID
	 * @param {array} rules
	 * @returns {string}
	 */
const generateUniqueRuleID = (ruleID, rules) => {
	if (ruleID && ruleID.split(id_seperator).length > 1) {
		return ruleID;
	}
	let uniqueID = null;
	let index = 0;
	let ruleSearch = null;

	while (null === uniqueID) {
		index++;
		ruleSearch = rules.find((rule) => rule.id == (ruleID + id_seperator + index));
		if (!ruleSearch) {
			uniqueID = ruleID + id_seperator + index;
		}
	}
	return uniqueID;
}

export {
	generateUniqueRuleID,
	id_seperator
};
